import defaultState from './defaultState'

const unwrapState = state => state.cmsJobs || defaultState

export const getCmsJobsList = (state) => unwrapState(state).items
export const getCmsJobsLoading = (state) => unwrapState(state).loading
export const getCmsJobsTotalSize = (state) => unwrapState(state).totalSize
